;((): void => {
    if (SiteInfo.isMobileVersion) {
        import("./starsTopCreatorStripeMobile.css")
    } else {
        import("./starsTopCreatorStripePc.css")
    }
})()
